import { Box, Button, Modal } from "@mui/material";
import { useCallback } from "react";
import { useDeleteExternalUser } from "../service/ClientManagementService";
import { useSnackbar } from "components/snackbar/SnackbarContext";

const DeleteAccountModal = ({ modalProps = {}, id, onClose }) => {
  const { setMessage } = useSnackbar();

  const { mutate: deleteAccount, loading: loadingDelete } =
    useDeleteExternalUser({
      id,
    });

  const handleDelete = useCallback(async () => {
    const response = await deleteAccount();
    if (response?.info?.description === "User deleted successfully") {
      setMessage({
        desc: "Successfully deleted account.",
        type: "success",
      });
      onClose();
    } else {
      setMessage({
        desc: "Failed to delete account. Please try again.",
        type: "error",
      });
    }
  }, [deleteAccount, onClose, setMessage]);

  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 560,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          px: "40px",
          py: "32px",
        }}
      >
        <div className='font-semibold mb-5 text-center'>
          Are you sure you want to delete this admin?
        </div>
        <div className='font-semibold mb-5 text-[#5F737F] text-center'>
          This action will permanently remove it from the system
        </div>
        <div className='flex flex-row gap-4 justify-center'>
          <Button variant='outlined' onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={loadingDelete}
            className='!bg-[#556FB5]'
            onClick={handleDelete}
            variant='contained'
          >
            Yes
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteAccountModal;
